import { Injectable } from '@angular/core'
import { events } from 'aws-amplify/data'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class EventsService {
  subscribe<T>(channelPath: string): Observable<T> {
    return new Observable<T>((subscriber) => {
      let channel: Awaited<ReturnType<typeof events.connect>> | null = null
      let closed = false

      const connectionPromise = events.connect(channelPath)

      connectionPromise
        .then((ch) => {
          if (closed) {
            ch.close()
            return
          }
          channel = ch
          channel.subscribe({
            next: (data) => {
              try {
                const parsed = typeof data.event === 'string' ? JSON.parse(data.event) : data.event
                subscriber.next(parsed as T)
              } catch {
                subscriber.next(data.event as T)
              }
            },
            error: (err) => {
              console.error(`[EventsService] Error on channel ${channelPath}:`, err)
              subscriber.error(err)
            },
          })
        })
        .catch((err) => {
          if (!closed) {
            console.error(`[EventsService] Failed to connect to channel ${channelPath}:`, err)
            subscriber.error(err)
          }
        })

      return () => {
        closed = true
        if (channel) {
          channel.close()
        }
      }
    })
  }
}
